import * as React from 'react';

interface UserProfileProps {
  className?: string;
}

export function UserAccountProfile({ className }: UserProfileProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-2 2a8 8 0 0 0-8 8h20a8 8 0 0 0-8-8h-4Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
